import React from "react";
import {CssBaseline} from "@material-ui/core";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { AppViews } from "./components/AppViews";
import { Login } from "./components/Login/Login";
import { PrivateRoute } from "./components/PrivateRoute";
import { AppStore } from "./store";
import ThemeProvider from "./Theme/ThemeProvider";
import { HelmetProvider } from 'react-helmet-async';


const App: React.FC = () => {
  return (
    <HelmetProvider>
    <AppStore>
      <BrowserRouter>
        <ThemeProvider>
        <CssBaseline />
          <Switch>
            <Route exact path="/login" render={() => <Login />} />
            <PrivateRoute
              path="/"
              render={() => <AppViews />}
              fallbackTo="/login"
            />
          </Switch>
        </ThemeProvider>
      </BrowserRouter>
    </AppStore>
    </HelmetProvider>
  );
};

export default App;
